/* HANDYCOR MOTION — IntersectionObserver + перетекание эпох.
   Ноль зависимостей. Всё уважает prefers-reduced-motion. */
(function () {
  'use strict';

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SELECTOR = '.hc-rise, .hc-track, .hc-rule';
  var timers = [];

  /* --- 01 / 05 / 06 : появление при попадании в кадр --------------------- */
  function revealAll(root) {
    var nodes = (root || document).querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    if (reduce || !('IntersectionObserver' in window)) {
      for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('hc-in');
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target;
          el.classList.add('hc-in');
          io.unobserve(el);
          window.setTimeout(function () {
            el.classList.add('hc-done');
          }, 2400);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    for (var j = 0; j < nodes.length; j++) io.observe(nodes[j]);
  }

  /* --- 10 : главы получают hc-seen, когда попали в кадр ------------------ */
  function markChapters(root) {
    var items = (root || document).querySelectorAll('.handycor-manifesto-item');
    if (!items.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('hc-seen');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.2 }
    );
    for (var i = 0; i < items.length; i++) io.observe(items[i]);
  }

  /* --- 03 : медленный наезд на первом экране ----------------------------- */
  function slowZoom(root) {
    var hero = (root || document).querySelector(
      '#shopify-section-template--16379628257518__166194024524cf144a'
    );
    if (!hero || reduce) return;
    window.requestAnimationFrame(function () {
      window.setTimeout(function () {
        hero.classList.add('hc-zoom');
      }, 120);
    });
  }

  /* --- 08 : перетекание эпох (кадр той же эпохи) ------------------------- */
  function eraCrossfade(root) {
    if (reduce) return;
    var bgs = (root || document).querySelectorAll('.handycor-era-bg');
    for (var i = 0; i < bgs.length; i++) {
      (function (bg, index) {
        if (!bg.querySelector('.hc-alt')) return;
        var t = window.setInterval(function () {
          bg.classList.toggle('hc-swap');
        }, 7000 + index * 900);
        timers.push(t);
      })(bgs[i], i);
    }
  }

  function clearTimers() {
    for (var i = 0; i < timers.length; i++) window.clearInterval(timers[i]);
    timers = [];
  }

  function init(root) {
    revealAll(root);
    markChapters(root);
    slowZoom(root);
    eraCrossfade(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* пересборка после перерисовки секции в редакторе темы */
  document.addEventListener('shopify:section:load', function (event) {
    clearTimers();
    init(event.target || document);
  });
  document.addEventListener('shopify:section:unload', clearTimers);
})();
